<template>
  <!-- Static sidebar for desktop -->
  <div class="hidden lg:flex lg:flex-shrink-0">
    <div class="flex flex-col w-64 border-r border-gray-200 pt-5 pb-4 bg-gray-100">
      <div class="flex items-center flex-shrink-0 px-6">
        <router-link to="/" class="h-4 w-auto mx-auto">
        <!-- <img
          class="h-4 w-auto mx-auto"
          src="data:image/png;base64,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"
          alt="Workflow"
        /> -->
        </router-link>
      </div>
      <!-- Sidebar component, swap this element with another sidebar if you like -->
      <div class="h-0 flex-1 flex flex-col overflow-y-auto">
        <!-- User account dropdown -->
        <div
          x-data="{ open: false }"
          @keydown.escape="open = false"
          click.away="open = false"
          class="px-3 mt-6 relative inline-block text-left"
        >
          <div
            x-description="Dropdown menu toggle, controlling the show/hide state of dropdown menu."
          >
            <button
              @click="showMenu()"
              type="button"
              class="group w-full rounded-md px-3.5 py-2 text-sm leading-5 font-medium text-gray-700 hover:bg-gray-50 hover:text-gray-500 focus:outline-none focus:bg-gray-200 focus:border-blue-300 active:bg-gray-50 active:text-gray-800 transition ease-in-out duration-150"
              id="options-menu"
              aria-haspopup="true"
              x-bind:aria-expanded="open"
            >
              <div class="flex w-full justify-between items-center">
                <div class="flex min-w-0 items-center justify-between space-x-3">
                  <img
                    :class="{ 'animate-pulse': loading }"
                    class="w-10 h-10 bg-gray-300 rounded-full flex-shrink-0"
                    :src="(user.gender == 'Masculino') ? Hombre : Mujer"
                  />
                  <div class="flex-1 min-w-0">
                    <h2 class="text-gray-900 text-sm leading-5 font-medium truncate">
                      {{ user.fullName }}
                    </h2>
                    <p class="text-gray-500 text-sm leading-5 truncate">
                      {{ user.email }}
                    </p>
                  </div>
                </div>
                <svg
                  class="flex-shrink-0 h-5 w-5 text-gray-400 group-hover:text-gray-500"
                  x-description="Heroicon name: selector"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
              </div>
            </button>
          </div>
          <div
            v-show="menuStatus"
            class="z-10 mx-3 origin-top absolute right-0 left-0 mt-1 rounded-md shadow-lg"
            style="display: none"
          >
            <div
              class="rounded-md bg-white shadow-xs"
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="options-menu"
            >
              <div class="border-t border-gray-100"></div>
              <div class="py-1">
                <a
                  href="/cliente/mi-perfil"
                  
                  class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                  role="menuitem"
                  >
                  Mi Perfil</a
                >
              </div>
            </div>
            <div
              class="rounded-md bg-white shadow-xs"
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="options-menu"
            >
              <div class="border-t border-gray-100"></div>
              <div class="py-1">
                <a
                  href="#"
                  @click="logout()"
                  class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                  role="menuitem"
                  >Cerrar sesión</a
                >
              </div>
            </div>
          </div>
        </div>
        
        <!-- Navigation -->
        <nav class="px-3 mt-6">
          <div class="space-y-1">
            <router-link to="/cotizacion"
              active-class="bg-gray-200 focus:bg-gray-50"
              class="group flex items-center px-2 py-2 text-sm leading-5 font-medium rounded-md text-gray-900 focus:outline-none transition ease-in-out duration-150"
              tag="button"
            >
              <svg
                class="mr-3 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-600 transition ease-in-out duration-150"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
                />
              </svg>
              COTIZAR
            </router-link>

            <router-link to="/cliente/inicio"
              active-class="bg-gray-200 focus:bg-gray-50"
              class="group flex items-center px-2 py-2 text-sm leading-5 font-medium rounded-md text-gray-700 hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition ease-in-out duration-150"
              tag="button"
            >
              <svg
                  class="mr-3 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-600 transition ease-in-out duration-150"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M4 6h16M4 10h16M4 14h16M4 18h16"
                  />
                </svg>
              Inicio
            </router-link>

            <router-link to="/cliente/mis-cotizaciones"
              active-class="bg-gray-200 focus:bg-gray-50"
              class="group flex items-center px-2 py-2 text-sm leading-5 font-medium rounded-md text-gray-700 hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition ease-in-out duration-150"
              tag="button"
            >
              <svg
                class="mr-3 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-600 transition ease-in-out duration-150"
                x-description="Heroicon name: view-list"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 6h16M4 10h16M4 14h16M4 18h16"
                ></path>
              </svg>
              Mis Cotizaciones
            </router-link>

            <router-link to="/cliente/mis-polizas"
              active-class="bg-gray-200 focus:bg-gray-50"
              class="group flex items-center px-2 py-2 text-sm leading-5 font-medium rounded-md text-gray-700 hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition ease-in-out duration-150"
              tag="button"
            >
              <svg
                class="mr-3 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-600 transition ease-in-out duration-150"
                x-description="Heroicon name: view-list"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 6h16M4 10h16M4 14h16M4 18h16"
                ></path>
              </svg>
              Mis Pólizas
            </router-link>

            <router-link to="/cliente/mis-pagos"
              active-class="bg-gray-200 focus:bg-gray-50"
              class="group flex items-center px-2 py-2 text-sm leading-5 font-medium rounded-md text-gray-700 hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition ease-in-out duration-150"
              tag="button"
            >
              <svg
                class="mr-3 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-600 transition ease-in-out duration-150"
                x-description="Heroicon name: view-list"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 6h16M4 10h16M4 14h16M4 18h16"
                ></path>
              </svg>
              Pagos
            </router-link>

            <router-link to="/cliente/contacto-aseguradoras"
              active-class="bg-gray-200 focus:bg-gray-50"
              class="group flex items-center px-2 py-2 text-sm leading-5 font-medium rounded-md text-gray-700 hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition ease-in-out duration-150"
              tag="button"
            >
              <svg
                class="mr-3 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-600 transition ease-in-out duration-150"
                x-description="Heroicon name: view-list"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 6h16M4 10h16M4 14h16M4 18h16"
                ></path>
              </svg>
              Contacto aseguradoras
            </router-link>

          </div>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "@vue/runtime-core";
import { getUserAuthInfo } from "@/helpers/auth.js";
// import Img from "@/assets/images/dashboard/circle_transparent.png";
import Hombre from '@/assets/images/dashboard/hombre.png';
import Mujer from '@/assets/images/dashboard/mujer.png';
import { deleteUserAuth } from "@/helpers/auth.js";

export default {
  setup() {
    const user = ref({
      image: "",
      firstName: "",
      middleName: "",
      lastName: "",
      fullName: "",
      shortName: "",
      email: "",
      role: "",
      gender: ""
    });

    const loading = ref(true);

    const menuStatus = ref(false);

    const showUserInfo = () => {
      const data = getUserAuthInfo();

      if (data) {
        user.value.image = data.image != null ? data.image : "";
        user.value.firstName = data.persona.nombres;
        user.value.lastName = `${data.persona.apellido_paterno} ${data.persona.apellido_materno}`;
        user.value.middleName = "";
        user.value.fullName = `${user.value.firstName} ${user.value.lastName}`;
        user.value.shortName = `${user.value.firstName} ${user.value.lastName}`;
        user.value.email = data.email;
        user.value.role = data.rol;
        user.value.gender = data.persona.sexo;

        setTimeout(() => {
          loading.value = false;
        }, 2000);
      }
    };

    const showMenu = () => {
      menuStatus.value = !menuStatus.value;
    };

    const logout = () => {
      deleteUserAuth();
    };

    onMounted(() => {
      showUserInfo();
    });

    return {
      user,
      loading,
      Hombre,
      Mujer,
      menuStatus,
      showMenu,
      logout,
    };
  },
};
</script>
